module.exports = __webpack_public_path__ + "media/post-listing-block-2-image.98cefcb5.jpg";